import { useCallback, useEffect, useState } from 'react';
import { DatePicker, Select, Tag, Input, Form, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { useAuthContext } from '../../contexts/AuthContext';
import { useErrorMessage } from '../../utils/errorMessage';
import { userRoles } from '../../utils/constants/tagColors';
import { countryCallingCodeOptions } from '../../utils/countryCodes';

const { Option } = Select;

const useFields = () => {
  const { message } = useErrorMessage();
  const { t } = useTranslation();
  const { dispatchAPI } = useAuthContext();
  const [isLoading, setIsLoading] = useState(false);
  const [enums, setEnums] = useState({});

  const fields = [
    {
      name: ['last_name'],
      rules: [{ required: false }]
    },
    {
      name: ['first_name'],
      rules: [{ required: false }]
    },
    {
      name: ['role'],
      required: false,
      input: (
        <Select loading={isLoading}>
          {(enums.roles || []).map((role) => (
            <Option key={role} value={role}>
              <Tag color={userRoles[role.split(':')[1]]}>
                {t(`users.tags.${role.split(':')[1]}`)}
              </Tag>
            </Option>
          ))}
        </Select>
      )
    },
    {
      name: ['permission'],
      required: true,
      input: (
        <Select loading={isLoading}>
          {(enums.roles || []).map((role) => (
            <Option key={role} value={role}>
              <Tag color={userRoles[role.split(':')[1]]}>
                {role.split(':')[1]}
              </Tag>
            </Option>
          ))}
        </Select>
      )
    },
    {
      name: ['email'],
      rules: [{ required: false }]
    },
    {
      name: ['phone_number'],
      label: 'phone_number.number',
      input: (
        <Space.Compact>
          <Form.Item
            noStyle
            name={['phone_number', 'country_code']}
            initialValue="+33"
          >
            <Select style={{ width: 90 }} options={countryCallingCodeOptions} />
          </Form.Item>
          <Form.Item noStyle name={['phone_number', 'number']}>
            <Input style={{ width: 'calc(100% - 90px)' }} />
          </Form.Item>
        </Space.Compact>
      )
    },
    {
      name: ['date_of_birth'],
      input: <DatePicker />
    },
    {
      label: 'address.number',
      name: ['address', 'number']
    },
    {
      label: 'address.street',
      name: ['address', 'street']
    },
    {
      label: 'address.additional',
      name: ['address', 'additional']
    },
    {
      label: 'address.postal_code',
      name: ['address', 'postal_code']
    },
    {
      label: 'city',
      name: ['address', 'city']
    }
  ];

  const getEnums = async () => {
    try {
      const { data } = await dispatchAPI('GET', { url: '/users/enums' });
      setEnums(data);
    } catch (e) {
      if (e.response) message(e.response.status);
    }
  };

  const getSelectOptions = useCallback(async () => {
    setIsLoading(true);
    await getEnums();
    setIsLoading(false);
  }, []);

  useEffect(() => {
    (async () => {
      await getSelectOptions();
    })();
  }, [getSelectOptions]);

  return {
    fields
  };
};

export default useFields;
